import { render } from "./SearchFailIcon.vue?vue&type=template&id=4b610e77"
import script from "./SearchFailIcon.vue?vue&type=script&lang=js"
export * from "./SearchFailIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__